import { render, staticRenderFns } from "./index.vue?vue&type=template&id=26b1e16a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b1e16a')) {
      api.createRecord('26b1e16a', component.options)
    } else {
      api.reload('26b1e16a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=26b1e16a", function () {
      api.rerender('26b1e16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkPercentInput/index.vue"
export default component.exports